import React, {Component, useState} from 'react';
import styled from "styled-components";
import Premium from '../../assets/Premium.png';
import MobilePremium from '../../assets/MobilePremium.svg'
import formatCurrency from "../../utils/format-currency";
import {Link} from "react-router-dom";
import Arrow from '../../assets/Arrow.png';
import {_getPolicy} from "../../store/policy/service";
import {connect} from 'react-redux';
import {mdDownN, xsDown} from "../../ui/common";
import PolicyWording from "../../assets/pdf/BIZ_Policy Wording_COMBINED_141220.pdf";
import { _gaPushEvent } from '../../utils/utility';

const LeftNavGroupStyle = styled.div`
    position: absolute;
    top: 144px;
    left: 137px;
    width: 260px;
    height:auto;
    ${mdDownN`
        position: fixed;
        top: auto;
        left: 0px;
        bottom:0px;
        // display: flex;
        // flex-direction: row;
        width: calc(100vw);
        background: linear-gradient(90deg, #003DA5 0%, #00A8F3 100%);
        align-items: flex-start;
        z-index:2;
        // border-left: 4px solid linear-gradient(180deg, #68D88E 0%, #00D5BE 100%);
  display: grid;
  grid-template-columns: 90px 1fr;
  // grid-template-rows: 1auto 1auto 1auto 1auto 1auto;
  gap: 0px 0px;
  grid-template-areas: "icon info" "title title" "titleDesc titleDesc" "uen uen" "download download" "bottom bottom";
        display: -ms-grid;
        -ms-grid-columns: 90px 1fr;
        -ms-grid-rows: 1auto 1auto 1auto 1auto 1auto 1auto;
        // ::before{
        //     content: '';
        //     width: 4px;
        //     height: 90px;
        //     display: inline-block;
        //     background: linear-gradient(180deg, #68D88E 0%, #00D5BE 100%);
        // }
    `}
`;

const LeftNavTopStyle = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    height: 4px;
    width: 260px;
    background: linear-gradient(180deg, #68D88E 0%, #00D5BE 100%);
    ${mdDownN`
        display: ${({showDetail}) => showDetail ? 'block' : 'none'};
        position: relative;
        align-self: stretch;
        // bottom: 0px;
        // left: 0px;
        grid-area: bottom;
        width: 100vw;
        height: 4px;
        -ms-grid-row: 6;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
   `}
`;

const LeftNavIconStyle = styled.img`
    position: absolute;
    top: 25px;
    left: 20px;
    height: 45px;
    width: 45px;
    ${mdDownN`
        display:none;
    `}
`;
const LeftMobileNavIconStyle = styled.img`
    display:none;
    ${mdDownN`
        display: block;
        position: relative;
        top: auto;
        left: auto;
        height: 43.8px;
        width: 43.8px;
        margin-left:20px;
        margin-right:20px;
        margin-top:11px;
        // filter: invert(100%);
        grid-area: icon;
    `}
    ${xsDown`
    grid-area: icon;
        height: 40.8px;
        width: 40.8px;
        margin-left:15px;
        margin-right:15px;
        -ms-grid-row: 1;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 1;
    `}
`;

const LeftNavBorderStyle = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 261px;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #C9CED6;
    box-shadow: 4px 4px 12px 0 rgba(20,40,75,0.2);
    ${mdDownN`
        // display:none;
        // height: 500px;
        // width: 4px;
        // bottom: 90px;
        // background: linear-gradient(180deg, #68D88E 0%, #00D5BE 100%);
        // box-shadow: none;
        display:none;

    `}
`;

const LeftNavTitleStyle = styled.div`
    margin-top: 83px;
    margin-left: 20px;
    height: 28px;
    width: 189px;
    font-family: Stag-Medium;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 26px;
    text-align: left;
    ${mdDownN`
         padding-left:90px;
         display: ${({showDetail}) => showDetail ? 'block' : 'none'};
         grid-area: title; 
         background-color: #fff;
         margin:0;
         width 100vw;
         
         padding-top:17px;
         padding-bottom:4px;
         min-height:49px;
        -ms-grid-row: 2;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
    `}
`;

const LeftNavBodyGroupStyle = styled.div`
    margin-top: 16px;
    margin-left: 20px;
    width: 200px;
    height: auto;
    display: ${({uen}) => {
        return uen ? 'block' : 'none'   
    }};
    ${mdDownN`
        padding-left:90px;
        grid-area: uen;
        display: ${({showDetail,uen}) => showDetail && uen ? 'block' : 'none'};
        background-color: #fff;
        left:0;
        width:100vw;
        margin:0px;
        padding-bottom:3px;
        -ms-grid-row: 4;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
    `}
`;

const LeftNavBodyTitleStyle = styled.div`
    position: relative;
    height: 30px;
    width: 200px;
    color: #0A1F44;
    font-family: Inter-SemiBold;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: left;
`;

const LeftNavBodyHeadingStyle = styled.div`
    position: relative;
    height: 21px;
    width: 200px;
    color: #717D92;
    font-family: Inter-Regular;
    font-size: 12px;
    line-height: 21px;
    letter-spacing: 0.5px;
    text-align: left;
`;

const LeftNavBodyValueStyle = styled.div`
    position: relative;
    height: 33px;
    width: 200px;
    color: #717D92;
    font-family: Inter-Medium;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0.5px;
    color: #0A1F44;
    text-align: left;
    margin-bottom: 12px;
`;

const LeftNavFooterGroupStyle = styled.div`
    margin-top: 35px;
    margin-left: 0.5px;
    width: 260px;
    background: linear-gradient(90deg, #003DA5 0%, #00A8F3 100%);
    ${mdDownN`
     grid-area: info;
        width: 100%;
        margin-top: 0px;
        margin-left: auto;
        display:flex;
        flex-direction: column;
        padding-top:11px;
        justify-content: flex-start; 
        height: auto;
        background: transparent;
        -ms-grid-row: 1;
        -ms-grid-row-span: 1;
        -ms-grid-column: 2;
        -ms-grid-column-span: 1;
    `}
`;

const LeftNavFooterHeadingStyle = styled.div`
    margin-left: 20px;
    padding-top: 15px;
    height: 24px;
    width: 200px;
    color: #FFFFFF;
    font-family: Inter-Medium;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: left;
    ${mdDownN`
        width: 100%;
        margin-top: 0px;
        margin-left: 0px;
        font-family: Inter-SemiBold;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0;
        line-height: 16px;
        margin-left: auto;
        padding-top: 0px;
    `}
    ${xsDown`
        font-size:11px;
    `}
`;

const LeftNavFooterValueStyle = styled.div`
    padding-top: 15px;
    margin-left: 20px;
    height: 36px;
    width: 200px;
    color: #FFFFFF;
    font-family: Inter-Bold;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    line-height: 36px;
    text-align: left;
    ${mdDownN`
        color: #FFFFFF;
        font-family: Inter-Bold;
        font-size: 24px;
        font-weight: bold;
        letter-spacing: -0.8px;
        line-height: 32px;
        height: 54px;
        padding-top: 0px;
        margin-left: 0px;

        line-height: 32px;
    `}
`;

const LeftNavFooterValueDetailsStyle = styled.div`
    color: white;
    padding-left: 20px;
    font-family: Inter-Medium;
    margin-top: 40px;
    font-size: 14px;
    padding-bottom: 20px;
    display: ${({showDetail}) => showDetail ? 'block' : 'none'};
    border-bottom: 1px solid #009AE4;
    
    p {
        margin: 0;
        padding: 0;
    }
    
    div {
        display: inline-block;
    }
    
    div.values {
        margin-left: 15px;
    }
    
    div.threeOrLess {
        display: ${({length}) => length <= 3 ? 'block' : 'none'};
    } 
    
    div.greaterThanThree {
        display: ${({length}) => length > 3 ? 'block' : 'none'}
    }
    
    ${mdDownN`
        padding-left: 0;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 21px;

        margin-top: 0px;
        padding-top: 0px;
        padding-bottom: 23px;
    `}
`;

const LeftNavFooterLinkStyle = styled.div`
    margin-top: 20px;
    margin-left: 20px;
    height: 18px;
    width: 200px;
    color: white;
    font-family: Inter-Regular;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.5px;
    text-align: left;
    padding-bottom: 35px;
    position: relative;
    
    a:visited {
        color: white;
    }
    
    img {
        height: 7px;
        width: 11px;
        margin-left: 5px;
        transform: ${({showDetail}) => showDetail ? 'rotate(180deg)' : 'rotate(0deg)'};
    }
    ${mdDownN`
        height:auto;
        position:absolute;
        right:16px;
        top:11px;
        width: auto;
        font-family: Inter-Medium;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 18px;
        text-align: right;
        margin: 0px;
    `}
    ${xsDown`
        font-size:11px;
        right:7px;
    `}
`;
const LeftNavFooterBufferStyle = styled.div`
    width: 7px;
    height: 7px;
    display: inline-block;
    ${xsDown`
        
        width: 3px;
        height: 3px;
    `}
`

const LeftNavDescriptionStyleDiv = styled.div`
    font-family: "Inter-Medium", Arial, Helvetica;
    font-size: 12px;
    margin-top: 4px;
    margin-left: 20px;
    margin-bottom: 20px;
    ${mdDownN`
        padding-left:90px;
        display: ${({showDetail}) => showDetail ? 'block' : 'none'};
        grid-area: titleDesc;
        background-color: #fff;
        margin:0;
        width: 100vw;
        padding-top:4px;
        padding-bottom:13px;
        font-size: 14px;
        line-height:21px;
        -ms-grid-row: 3;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
    `}
`;

const LeftNavPolicyWordingStyleDiv = styled.div`
    font-family: "Inter-Medium", Arial, Helvetica;
    font-size: 12px;
    margin-left: 20px;
    position: relative;
    ${mdDownN`
        padding-left:90px;
        display: ${({showDetail}) => showDetail ? 'block' : 'none'};
        grid-area: download; 
        background-color: #fff;
        width: 100vw;
        margin:0;
        padding-bottom:19px;
        font-size: 14px;
        
        -ms-grid-row: 5;
        -ms-grid-row-span: 1;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
    `}
`;

const LeftNavLink = styled(Link)`
    &:hover, 
    &:visited, 
    &:active, 
    &:default {
        color: #003DA5;
    }
`

const Leftnav = (props) => {
    const [showDetail, setShowDetail] = useState(false);

    const selectShowDetail = () => {
        setShowDetail(!showDetail);
    }

    const businessTypeText = () => {
        if (props.policy?.policySME?.occupationCode == '511035') {
            return 'Groceries Store';
        } else if (props.policy?.policySME?.occupationCode == '511010') {
            return 'Retail Shop';
        } else if (props.policy?.policySME?.occupationCode == '785405') {
            return 'Office';
        }
    }

    const occupationTypeText = () => {
        if (props.policy?.policySME?.occupationCode == '511035') {
            return 'Groceries';
        } else if (props.policy?.policySME?.occupationCode == '511010') {
            return 'Retail';
        } else if (props.policy?.policySME?.occupationCode == '785405') {
            return 'Office';
        }
    }

    return (
        <LeftNavGroupStyle>
            <LeftNavBorderStyle/>
            <LeftNavTopStyle showDetail={showDetail}/>
            <LeftNavIconStyle src={Premium} />
            <LeftMobileNavIconStyle src={MobilePremium} />
            <LeftNavTitleStyle showDetail={showDetail}>
                {businessTypeText()}
            </LeftNavTitleStyle>
            <LeftNavDescriptionStyleDiv showDetail={showDetail}>{occupationTypeText()}</LeftNavDescriptionStyleDiv>

            <LeftNavBodyGroupStyle showDetail={showDetail} uen={props.policy.policySME.applicant.uen}>
                <LeftNavBodyHeadingStyle>
                    UEN no.
                </LeftNavBodyHeadingStyle>
                <LeftNavBodyValueStyle>
                    {props.policy.policySME.applicant.uen}
                </LeftNavBodyValueStyle>
                <LeftNavBodyHeadingStyle>
                    Business name
                </LeftNavBodyHeadingStyle>
                <LeftNavBodyValueStyle>
                    {props.policy.policySME.applicant.fullName}
                </LeftNavBodyValueStyle>

            </LeftNavBodyGroupStyle>

            <LeftNavPolicyWordingStyleDiv showDetail={showDetail}>
                <LeftNavLink onClick={() => {window.open(PolicyWording, '_blank'); _gaPushEvent('DownloadPolicyWording');}}>Download Policy Wordings</LeftNavLink>
            </LeftNavPolicyWordingStyleDiv>

            <LeftNavFooterGroupStyle>
                <LeftNavFooterHeadingStyle>
                    {props.policy.policySME.policyPremium.totalPremium === 0 ? 'Annual Premium starting at' : 'Annual Premium'}
                </LeftNavFooterHeadingStyle>
                <LeftNavFooterValueStyle>
                    SGD {formatCurrency(props.policy.policySME.totalDueAmount)}
                </LeftNavFooterValueStyle>
                <LeftNavFooterValueDetailsStyle showDetail={showDetail} length={props.policy.policySME.totalDueAmount.toString().length}>
                    <div className="threeOrLess">
                        <div>
                            <p>Premium excludes GST</p>
                            <p>GST</p>
                        </div>
                        <div className="values">
                            <p>{formatCurrency(props.policy?.policySME?.totalDueAmount
                                - (props.policy?.policySME?.policyPremium?.gst ? props.policy?.policySME?.policyPremium?.gst : 0))}</p>
                            <p>{formatCurrency(props.policy?.policySME?.policyPremium?.gst ? props.policy?.policySME?.policyPremium?.gst : 0)}</p>
                        </div>
                    </div>
                    <div className="greaterThanThree">
                        <div>
                            <p>Premium excludes GST</p>
                            <p>{formatCurrency(props.policy?.policySME?.totalDueAmount
                                - (props.policy?.policySME?.policyPremium?.gst ? props.policy?.policySME?.policyPremium?.gst : 0))}</p>
                            <br/>
                            <p>GST</p>
                            <p>{formatCurrency(props.policy?.policySME?.policyPremium?.gst ? props.policy?.policySME?.policyPremium?.gst : 0)}</p>
                        </div>
                    </div>
                </LeftNavFooterValueDetailsStyle>
                <LeftNavFooterLinkStyle showDetail={showDetail}>
                    <Link onClick={() => {
                             selectShowDetail();
                             if (!showDetail){
                                 _gaPushEvent('ViewDetails');
                             }
                          }}
                          style={{color:'white',textDecoration:'underline'}} to={'#'}>{showDetail ? 'Hide' : 'View'} Details
                        <LeftNavFooterBufferStyle ></LeftNavFooterBufferStyle>
                        <img src={Arrow}></img>
                    </Link>
                </LeftNavFooterLinkStyle>
            </LeftNavFooterGroupStyle>

        </LeftNavGroupStyle>
    );
}


const mapStateToProps = state => {
    return {
        policy: _getPolicy(state)
    }
};


export default connect(mapStateToProps)(Leftnav);
